export default __webpack_public_path__ + "static/media/s-squiggle-168.d24b2038.svg";